module.exports = __webpack_public_path__ + "media/assets/icons/messenger-263bea56a9cc2c4bff64b7e4f4506dee.svg";